import HelpCenterModel from './helpCenterModel.js';
import HelpCenterView from './helpCenterView.js';
import _ from 'underscore';

import VideoPageView from './video/videoPageView.js';
import VideoPageModel from './video/videoPageModel.js';
import GuidePageView from './guide/guidePageView.js';
import GuidePageModel from './guide/guidePageModel.js';
import FaqPageView from './faq/faqPageView.js';
import FaqPageModel from './faq/faqPageModel.js';

export function HelpCenter(extendedRegistry) {
    const registry = _.extend({
        video: { view: VideoPageView, model: VideoPageModel },
        guide: { view: GuidePageView, model: GuidePageModel },        
        faq: { view: FaqPageView, model: FaqPageModel }
    }, extendedRegistry || {});

    const model = new HelpCenterModel({}, registry);
    const view = new HelpCenterView({ model: model }, registry).render();

    this.appendTo = function(selector) { 
        view.$el.appendTo(selector);
    }

    //extend for all registry types    
    this.addPage = function(type, data, title) {
        return model.addPage(type, data, title);
    }

    _.each(registry, (info, name) => {
        let addName = 'add' + name.substr(0,1).toUpperCase() + name.substr(1) + 'Page';

        this[addName] = function(data, title) {
            this.addPage(name, data, title);
            return this;
        }
    });
};


/** WEBPACK FOOTER **
 ** ./client/helpCenter.js
 **/